
import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { Post } from "../newsItem";

@Component
export default class List extends Vue {
  @Prop() postList!: Post[];

  @Emit("delete-item")
  deleteItem(id: number, description: string): number | null {
    if (confirm(`${description}を削除してよいですか？`)) {
      return id;
    }
    return null;
  }
}
